var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import React, { useState, useMemo, useCallback } from "react";
import { v4 as uuidv4 } from "uuid";
import { useAuth0 } from "@auth0/auth0-react";
import { Dialog, Switch } from "@headlessui/react";
import useSWR from "swr";
import { Auth0Fetcher, StaticTable, CopyButton, StyledButton, StyledButtonStyle, } from "ee-react-components";
import { EDITABLE_OCPI_TOKEN_FLAGS, EDITABLE_OCPI_TOKEN_FLAG_KEYS, Permission, } from "ee-nestjs-interfaces";
import { ELECTRIC_ERA_PARTY_ID } from "ee-nestjs-interfaces";
import { usePermissions } from "../../PermissionsContext";
/**
 * The editable flags, in the order the shared definition lists them. Both the set and its labels
 * come from `ee-nestjs-interfaces`, which is also where noc-svc reads the allow-list it validates
 * against, so a flag can never be offered here and rejected there.
 */
var EDITABLE_FLAGS = EDITABLE_OCPI_TOKEN_FLAG_KEYS.map(function (key) { return (__assign({ key: key }, EDITABLE_OCPI_TOKEN_FLAGS[key])); });
export var NocThirdPartyAppToken = function () {
    var _a = useState(""), credentialA = _a[0], setCredentialA = _a[1];
    var _b = useState(""), credentialARecipient = _b[0], setCredentialARecipient = _b[1];
    var _c = useState(""), thirdPartyUrl = _c[0], setThirdPartyUrl = _c[1];
    var _d = useState(""), thirdPartyCountryCode = _d[0], setThirdPartyCountryCode = _d[1];
    var _e = useState(true), base64EncodeToken = _e[0], setBase64EncodeToken = _e[1];
    var _f = useState(false), supportsPushModel = _f[0], setSupportsPushModel = _f[1];
    var _g = useState(false), includeNonPayableSites = _g[0], setIncludeNonPayableSites = _g[1];
    var _h = useState("idle"), requestStatus = _h[0], setRequestStatus = _h[1];
    var _j = useState(""), errorMessage = _j[0], setErrorMessage = _j[1];
    var _k = useState({
        credentialA: "",
        credentialARecipient: "",
        thirdPartyUrl: "",
        thirdPartyCountryCode: "",
    }), validationMessages = _k[0], setValidationMessages = _k[1];
    var _l = useState(null), secretsForToken = _l[0], setSecretsForToken = _l[1];
    var _m = useState(null), flagsForToken = _m[0], setFlagsForToken = _m[1];
    var _o = useAuth0(), isAuthenticated = _o.isAuthenticated, isLoading = _o.isLoading, getAccessTokenSilently = _o.getAccessTokenSilently;
    // Provisioning partners, reading their tokens and changing their flags all require OCPI admin;
    // other NOC users keep read-only access to the table.
    var permissions = usePermissions();
    var canAdministerOcpi = permissions.hasPermission(Permission.OCPI_ADMIN);
    var _p = useSWR(isLoading || !isAuthenticated
        ? null
        : [
            "".concat(process.env.NOC_SVC_URL, "/reports/tokens/list"),
            getAccessTokenSilently,
        ], Auth0Fetcher), credentialTokensList = _p.data, refreshCredentialTokensList = _p.mutate;
    /**
     * Writes the given flags to one credential token and refreshes the table. Rejects on failure so
     * the edit dialog can keep itself open and show why, rather than closing over a lost change.
     */
    var updateTokenFlags = useCallback(function (id, flags) { return __awaiter(void 0, void 0, Promise, function () {
        var accessToken, response, _a, _b, _c;
        return __generator(this, function (_d) {
            switch (_d.label) {
                case 0: return [4 /*yield*/, getAccessTokenSilently({
                        authorizationParams: {
                            audience: process.env.AUTH0_AUDIENCE,
                        },
                    })];
                case 1:
                    accessToken = _d.sent();
                    return [4 /*yield*/, fetch("".concat(process.env.NOC_SVC_URL, "/reports/tokens/").concat(id, "/flags"), {
                            method: "PATCH",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: "Bearer ".concat(accessToken),
                            },
                            body: JSON.stringify(flags),
                        })];
                case 2:
                    response = _d.sent();
                    if (!!response.ok) return [3 /*break*/, 4];
                    _a = Error.bind;
                    _c = (_b = "Status ".concat(response.status, " - ").concat(response.statusText, ". Details: ")).concat;
                    return [4 /*yield*/, response.text()];
                case 3: throw new (_a.apply(Error, [void 0, _c.apply(_b, [_d.sent()])]))();
                case 4: return [4 /*yield*/, refreshCredentialTokensList()];
                case 5:
                    _d.sent();
                    return [2 /*return*/];
            }
        });
    }); }, [getAccessTokenSilently, refreshCredentialTokensList]);
    var generateTokenBAndSendCredentials = function () { return __awaiter(void 0, void 0, void 0, function () {
        var valid, newValidationMessages, accessToken, data, response, resErrMessage, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    valid = true;
                    newValidationMessages = {
                        credentialA: "",
                        credentialARecipient: "",
                        thirdPartyUrl: "",
                        thirdPartyCountryCode: "",
                    };
                    if (!credentialA) {
                        newValidationMessages.credentialA = "Please enter Credential A";
                        valid = false;
                    }
                    if (!thirdPartyUrl) {
                        newValidationMessages.thirdPartyUrl = "Please enter the Third Party Url";
                        valid = false;
                    }
                    setValidationMessages(newValidationMessages);
                    if (!valid)
                        return [2 /*return*/];
                    setRequestStatus("loading");
                    return [4 /*yield*/, getAccessTokenSilently({
                            authorizationParams: {
                                audience: process.env.AUTH0_AUDIENCE,
                            },
                        })];
                case 1:
                    accessToken = _c.sent();
                    data = {
                        tokenARecipient: ELECTRIC_ERA_PARTY_ID,
                        credentialTokenA: credentialA,
                        thirdPartyBaseUrl: thirdPartyUrl,
                        base64EncodeToken: base64EncodeToken,
                        supportsPushModel: supportsPushModel,
                        includeNonPayableSites: includeNonPayableSites,
                    };
                    return [4 /*yield*/, fetch("".concat(process.env.NOC_SVC_URL, "/reports/tokens/fetchAndAddCredentialTokens"), {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: "Bearer ".concat(accessToken),
                            },
                            body: JSON.stringify(data),
                        })];
                case 2:
                    response = _c.sent();
                    if (!!response.ok) return [3 /*break*/, 4];
                    _b = (_a = "Failed to send credentials. Status: ".concat(response.status, " - ").concat(response.statusText, ". Details: ")).concat;
                    return [4 /*yield*/, response.text()];
                case 3:
                    resErrMessage = _b.apply(_a, [_c.sent()]);
                    console.error(resErrMessage);
                    setErrorMessage(resErrMessage);
                    setRequestStatus("error");
                    return [2 /*return*/];
                case 4:
                    setRequestStatus("success");
                    console.log("Credentials successfully sent");
                    return [2 /*return*/];
            }
        });
    }); };
    var generateTokenAInDatabase = function () { return __awaiter(void 0, void 0, void 0, function () {
        var valid, newValidationMessages, credentialA;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    valid = true;
                    newValidationMessages = {
                        credentialA: "",
                        credentialARecipient: "",
                        thirdPartyUrl: "",
                        thirdPartyCountryCode: "",
                    };
                    if (!credentialARecipient) {
                        newValidationMessages.credentialARecipient =
                            "Please enter the recipient name";
                        valid = false;
                    }
                    if (!thirdPartyUrl) {
                        newValidationMessages.thirdPartyUrl = "Please enter the Third Party Url";
                        valid = false;
                    }
                    if (!thirdPartyCountryCode) {
                        newValidationMessages.thirdPartyCountryCode =
                            "Please enter the Third Party Country Code";
                        valid = false;
                    }
                    setValidationMessages(newValidationMessages);
                    if (!valid)
                        return [2 /*return*/];
                    credentialA = uuidv4();
                    console.log("uuid is ", credentialA);
                    if (!credentialA) return [3 /*break*/, 2];
                    return [4 /*yield*/, sendTokensToNOC(ELECTRIC_ERA_PARTY_ID, credentialARecipient, credentialA, "", "", thirdPartyUrl, base64EncodeToken, thirdPartyCountryCode)];
                case 1:
                    _a.sent();
                    _a.label = 2;
                case 2: return [2 /*return*/];
            }
        });
    }); };
    var sendTokensToNOC = function (credentialAOwner, credentialARecipient, tokenA, cpoToken, thirdPartyToken, thirdPartyBaseUrl, base64EncodeToken, countryCode) { return __awaiter(void 0, void 0, void 0, function () {
        var nocQuery, accessToken, credentialTokens, nocResponse, resErrMessage, _a, _b;
        return __generator(this, function (_c) {
            switch (_c.label) {
                case 0:
                    nocQuery = "".concat(process.env.NOC_SVC_URL, "/reports/addCredentialTokens");
                    return [4 /*yield*/, getAccessTokenSilently({
                            authorizationParams: {
                                audience: process.env.AUTH0_AUDIENCE,
                            },
                        })];
                case 1:
                    accessToken = _c.sent();
                    credentialTokens = {
                        TOKEN_A_OWNER: credentialAOwner,
                        TOKEN_A_RECIPIENT: credentialARecipient,
                        Credential_Token_A: tokenA,
                        CPO_TOKEN: cpoToken,
                        THIRD_PARTY_MSP_TOKEN: thirdPartyToken,
                        THIRD_PARTY_BASE_URL: thirdPartyBaseUrl,
                        base64EncodeToken: base64EncodeToken,
                        countryCode: countryCode,
                        supportsPushModel: supportsPushModel,
                        includeNonPayableSites: includeNonPayableSites,
                    };
                    return [4 /*yield*/, fetch(nocQuery, {
                            method: "POST",
                            headers: {
                                "Content-Type": "application/json",
                                Authorization: "Bearer ".concat(accessToken),
                            },
                            body: JSON.stringify(credentialTokens),
                        })];
                case 2:
                    nocResponse = _c.sent();
                    if (!!nocResponse.ok) return [3 /*break*/, 4];
                    _b = (_a = "Failed to send tokens to NOC. Status: ".concat(nocResponse.status, " - ").concat(nocResponse.statusText, ". Details: ")).concat;
                    return [4 /*yield*/, nocResponse.text()];
                case 3:
                    resErrMessage = _b.apply(_a, [_c.sent()]);
                    console.error(resErrMessage);
                    setErrorMessage(resErrMessage);
                    setRequestStatus("error");
                    return [2 /*return*/];
                case 4:
                    setRequestStatus("success");
                    return [2 /*return*/, true];
            }
        });
    }); };
    var columns = useMemo(function () { return __spreadArray(__spreadArray([
        {
            header: "Status",
            accessorFn: function (row) {
                return row.status === "NOT_USED" ? "NOT USED" : "USED";
            },
            size: 10,
        },
        {
            header: "Owner",
            accessorFn: function (row) { return row.owner; },
            size: 10,
        },
        {
            header: "Consumer",
            accessorFn: function (row) { return row.consumer; },
            size: 10,
        },
        {
            header: "URL",
            accessorFn: function (row) { return row.thirdPartyUrl; },
            size: 40,
        }
    ], EDITABLE_FLAGS.map(function (_a) {
        var key = _a.key, header = _a.header, helpText = _a.helpText;
        return ({
            header: header,
            helpText: helpText,
            accessorFn: function (row) { return (row[key] ? "Yes" : "No"); },
            size: 10,
        });
    }), true), (canAdministerOcpi
        ? [
            {
                // Must be a non-empty string: with no accessorKey, react-table derives the column
                // id from the header, and an empty id makes it throw while building the columns.
                header: "Actions",
                accessorFn: function () { return ""; },
                cell: function (_a) {
                    var row = _a.row;
                    return (React.createElement("div", { className: "flex flex-row gap-x-[8px]" },
                        React.createElement(StyledButton, { text: "EDIT", onClick: function () { return setFlagsForToken(row.original); } }),
                        React.createElement(StyledButton, { text: "VIEW", style: StyledButtonStyle.Gray, onClick: function () { return setSecretsForToken(row.original); } })));
                },
                size: 20,
            },
        ]
        : []), true); }, [canAdministerOcpi]);
    return (React.createElement("div", null,
        React.createElement("div", { className: "flex flex-col gap-y-[32px] pt-[32px]" },
            React.createElement("div", { className: "pt-[32px]" },
                React.createElement("h2", { className: "text-l font-bold mb-4 text-white" }, "Token Table"),
                React.createElement("p", { className: "text-black-400 font-N8 mb-4" }, canAdministerOcpi
                    ? "Use EDIT to change a partner's flags, or VIEW to see their credential tokens."
                    : "You need the OCPI admin permission to change these flags, view credential tokens or add a partner."),
                React.createElement(StaticTable, { data: credentialTokensList !== null && credentialTokensList !== void 0 ? credentialTokensList : [], columnDefinitions: columns, emptyMessage: "No tokens available." })),
            canAdministerOcpi && (React.createElement(React.Fragment, null,
                React.createElement("p", null,
                    " ",
                    "Enter the Third Party URL and choose a generate option based on our OCPI role: if Electric Era is the Sender (we initiate the handshake using their TOKEN_A), use option 1. If Electric Era is the Receiver (we generate a TOKEN_A to give to them), use option 2."),
                React.createElement("label", { className: "font-N6 text-white" }, "API Tokens"),
                React.createElement("div", null,
                    React.createElement("label", { className: "font-semibold text-white" }, "Enter Third Party URL:"),
                    React.createElement("input", { type: "text", value: thirdPartyUrl, onChange: function (e) { return setThirdPartyUrl(e.target.value); }, placeholder: "e.g. https://example.com/ocpi/emsp/2.2.1", className: "text-white p-3 rounded-md m-2 w-96", required: true }),
                    validationMessages.thirdPartyUrl && (React.createElement("div", { className: "text-red" }, validationMessages.thirdPartyUrl))),
                React.createElement("div", { className: "flex items-center gap-x-2" },
                    React.createElement("input", { type: "checkbox", id: "base64EncodeToken", checked: base64EncodeToken, onChange: function (e) { return setBase64EncodeToken(e.target.checked); } }),
                    React.createElement("label", { htmlFor: "base64EncodeToken", className: "font-semibold text-white" }, "Base64 encode token")),
                React.createElement("div", { className: "flex items-center gap-x-2" },
                    React.createElement("input", { type: "checkbox", id: "supportsPushModel", checked: supportsPushModel, onChange: function (e) { return setSupportsPushModel(e.target.checked); } }),
                    React.createElement("label", { htmlFor: "supportsPushModel", className: "font-semibold text-white" }, "Supports push model (we push location updates to them)")),
                React.createElement("div", { className: "flex items-center gap-x-2" },
                    React.createElement("input", { type: "checkbox", id: "includeNonPayableSites", checked: includeNonPayableSites, onChange: function (e) { return setIncludeNonPayableSites(e.target.checked); } }),
                    React.createElement("label", { htmlFor: "includeNonPayableSites", className: "font-semibold text-white" }, "Include non-payable sites (send all sites; strips remote start/RFID capabilities from sites without a payment integration)")),
                React.createElement("label", { className: "font-N6 text-white" }, "Generate and Send Token B for Third Party Usage"),
                React.createElement("div", { className: "flex flex-col gap-y-4" },
                    React.createElement("div", null,
                        React.createElement("label", { className: "font-semibold text-white" }, "Enter Credential A of Third Party:"),
                        React.createElement("input", { type: "text", value: credentialA, onChange: function (e) { return setCredentialA(e.target.value); }, placeholder: "Enter Credential A", className: "text-white p-3 rounded-md m-2 w-96", required: true }),
                        validationMessages.credentialA && (React.createElement("div", { className: "text-red" }, validationMessages.credentialA))),
                    React.createElement("button", { className: "px-[16px] py-[8px] rounded-[8px] bg-blue-700 hover:bg-blue-400 text-white w-fit", onClick: generateTokenBAndSendCredentials }, "Generate Token B and Send Credentials"))))),
        canAdministerOcpi && (React.createElement("div", { className: "flex flex-col gap-y-[32px] pt-[32px]" },
            React.createElement("label", { className: "font-N6 text-white" }, "Generate Token A for Third Party Usage"),
            React.createElement("div", null,
                React.createElement("label", { className: "font-semibold text-white" }, "Party ID of the Third Party Recipient:"),
                React.createElement("input", { type: "text", value: credentialARecipient, onChange: function (e) { return setCredentialARecipient(e.target.value); }, placeholder: "Enter Third Party Party ID", className: "text-white p-3 rounded-md m-2", required: true }),
                validationMessages.credentialARecipient && (React.createElement("div", { className: "text-red" }, validationMessages.credentialARecipient))),
            React.createElement("div", null,
                React.createElement("label", { className: "font-semibold text-white" }, "Third Party Country Code:"),
                React.createElement("input", { type: "text", value: thirdPartyCountryCode, onChange: function (e) { return setThirdPartyCountryCode(e.target.value); }, placeholder: "e.g. US", className: "text-white p-3 rounded-md m-2", required: true }),
                validationMessages.thirdPartyCountryCode && (React.createElement("div", { className: "text-red" }, validationMessages.thirdPartyCountryCode))),
            React.createElement("div", { className: "flex flex-col gap-y-4" },
                React.createElement("button", { className: "px-[16px] py-[8px] rounded-[8px] bg-blue-700 hover:bg-blue-400 text-white w-fit", onClick: generateTokenAInDatabase }, "Generate Token A")))),
        requestStatus === "success" && (React.createElement("div", { className: "text-green" }, "Request was successful!")),
        requestStatus === "loading" && (React.createElement("div", { className: "text-yellow" }, "Loading Request..")),
        requestStatus === "error" && (React.createElement("div", { className: "text-red" },
            "Request failed: ",
            errorMessage)),
        flagsForToken && (React.createElement(TokenFlagsDialog, { token: flagsForToken, onSave: function (flags) { return updateTokenFlags(flagsForToken.id, flags); }, onClose: function () { return setFlagsForToken(null); } })),
        secretsForToken && (React.createElement(TokenSecretsDialog, { token: secretsForToken, onClose: function () { return setSecretsForToken(null); } }))));
};
/**
 * Edits one partner's flags. Toggles are held locally and written only on Save, as a single PATCH
 * carrying just the flags that actually changed — so a partner is never left half-updated, and
 * reviewing a change before committing it is possible.
 */
var TokenFlagsDialog = function (_a) {
    var token = _a.token, onSave = _a.onSave, onClose = _a.onClose;
    // Seeded from the row once. Deliberately not resynced from later polls: overwriting someone's
    // half-made edit mid-dialog would be worse than saving against a slightly stale baseline, and
    // only the flags they actually touched get written anyway.
    var _b = useState(function () {
        return EDITABLE_FLAGS.reduce(function (acc, _a) {
            var key = _a.key;
            acc[key] = token[key];
            return acc;
        }, {});
    }), flags = _b[0], setFlags = _b[1];
    var _c = useState(false), saving = _c[0], setSaving = _c[1];
    var _d = useState(""), error = _d[0], setError = _d[1];
    var changedKeys = EDITABLE_FLAGS.filter(function (_a) {
        var key = _a.key;
        return flags[key] !== token[key];
    }).map(function (_a) {
        var key = _a.key;
        return key;
    });
    var save = function () { return __awaiter(void 0, void 0, void 0, function () {
        var e_1;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    setError("");
                    setSaving(true);
                    _a.label = 1;
                case 1:
                    _a.trys.push([1, 3, 4, 5]);
                    return [4 /*yield*/, onSave(changedKeys.reduce(function (acc, key) {
                            var _a;
                            return (__assign(__assign({}, acc), (_a = {}, _a[key] = flags[key], _a)));
                        }, {}))];
                case 2:
                    _a.sent();
                    onClose();
                    return [3 /*break*/, 5];
                case 3:
                    e_1 = _a.sent();
                    setError(e_1 instanceof Error ? e_1.message : String(e_1));
                    return [3 /*break*/, 5];
                case 4:
                    setSaving(false);
                    return [7 /*endfinally*/];
                case 5: return [2 /*return*/];
            }
        });
    }); };
    return (React.createElement(Dialog, { open: true, onClose: onClose, className: "relative z-50" },
        React.createElement("div", { className: "fixed inset-0 bg-black/90", "aria-hidden": "true" }),
        React.createElement("div", { className: "fixed inset-0 flex items-center justify-center p-4" },
            React.createElement(Dialog.Panel, { className: "bg-black-1100 border border-black-700 shadow-2xl rounded-[16px] p-[32px] w-full max-w-[640px] max-h-[90vh] overflow-y-auto flex flex-col gap-y-[16px]" },
                React.createElement(Dialog.Title, { className: "text-white font-N6" },
                    "Edit flags for ",
                    token.consumer),
                React.createElement("span", { className: "text-black-400 font-N8 break-all" }, token.thirdPartyUrl),
                EDITABLE_FLAGS.map(function (_a) {
                    var key = _a.key, header = _a.header, helpText = _a.helpText;
                    return (
                    // Switch.Group is what makes Switch.Label clickable and the switch's accessible name;
                    // a plain <label> would not, since Headless UI renders the switch as a <button>.
                    React.createElement(Switch.Group, { key: key, as: "div", className: "flex flex-row items-start gap-x-[16px]" },
                        React.createElement(FlagSwitch, { checked: flags[key], disabled: saving, onChange: function (value) {
                                return setFlags(function (current) {
                                    var _a;
                                    return (__assign(__assign({}, current), (_a = {}, _a[key] = value, _a)));
                                });
                            } }),
                        React.createElement("div", { className: "flex flex-col gap-y-[4px]" },
                            React.createElement(Switch.Label, { className: "text-white font-N7 cursor-pointer" }, header),
                            React.createElement("span", { className: "text-black-400 font-N8" }, helpText))));
                }),
                error && (React.createElement("div", { className: "text-red font-N8" },
                    "Failed to save: ",
                    error)),
                React.createElement("div", { className: "flex flex-row justify-end gap-x-[8px]" },
                    React.createElement(StyledButton, { text: "Cancel", style: StyledButtonStyle.Gray, onClick: onClose, disabled: saving }),
                    React.createElement(StyledButton, { text: saving ? "Saving..." : "Save", onClick: save, disabled: saving || changedKeys.length === 0 }))))));
};
/**
 * The switch itself, with no opinion about persistence — its owner decides when a value is written.
 * Expects to sit in a Switch.Group, which supplies its accessible name.
 */
var FlagSwitch = function (_a) {
    var checked = _a.checked, disabled = _a.disabled, onChange = _a.onChange;
    return (React.createElement(Switch, { checked: checked, onChange: onChange, disabled: disabled, className: "".concat(checked ? "bg-blue-600" : "bg-gray-500", " relative inline-flex h-6 w-11 shrink-0 items-center rounded-full transition-colors focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:ring-offset-2 disabled:opacity-50") },
        React.createElement("span", { className: "".concat(checked ? "translate-x-6" : "translate-x-1", " inline-block h-4 w-4 transform rounded-full bg-white transition-transform") })));
};
/**
 * Shows the credential values for one partner, fetched on open from the dedicated secrets
 * endpoint so the token list itself never carries them.
 */
var TokenSecretsDialog = function (_a) {
    var token = _a.token, onClose = _a.onClose;
    var getAccessTokenSilently = useAuth0().getAccessTokenSilently;
    var _b = useSWR([
        "".concat(process.env.NOC_SVC_URL, "/reports/tokens/").concat(token.id, "/secrets"),
        getAccessTokenSilently,
    ], Auth0Fetcher, 
    // These are credentials; do not keep re-requesting them behind the global 5s poll.
    { refreshInterval: 0, revalidateOnFocus: false }), secrets = _b.data, error = _b.error, isLoading = _b.isLoading;
    return (React.createElement(Dialog, { open: true, onClose: onClose, className: "relative z-50" },
        React.createElement("div", { className: "fixed inset-0 bg-black/90", "aria-hidden": "true" }),
        React.createElement("div", { className: "fixed inset-0 flex items-center justify-center p-4" },
            React.createElement(Dialog.Panel, { className: "bg-black-1100 border border-black-700 shadow-2xl rounded-[16px] p-[32px] w-full max-w-[640px] max-h-[90vh] overflow-y-auto flex flex-col gap-y-[16px]" },
                React.createElement(Dialog.Title, { className: "text-white font-N6" },
                    "Tokens for ",
                    token.consumer),
                isLoading && React.createElement("div", { className: "text-yellow font-N8" }, "Loading..."),
                error && (React.createElement("div", { className: "text-red font-N8" },
                    "Failed to load tokens: ",
                    error.message)),
                secrets && (React.createElement(React.Fragment, null,
                    React.createElement(SecretField, { label: "Credentials Token A (one-time handshake token)", value: secrets.credentialsTokenA }),
                    React.createElement(SecretField, { label: "CPO Token (they present this when calling us)", value: secrets.cpoToken }),
                    React.createElement(SecretField, { label: "Third Party MSP Token (we present this when calling them)", value: secrets.thirdPartyMspToken }),
                    React.createElement(SecretField, { label: "Third Party URL", value: secrets.thirdPartyUrl }),
                    React.createElement(SecretField, { label: "Country Code", value: secrets.countryCode }))),
                React.createElement("div", { className: "flex flex-row justify-end" },
                    React.createElement(StyledButton, { text: "Close", style: StyledButtonStyle.Gray, onClick: onClose }))))));
};
var SecretField = function (_a) {
    var label = _a.label, value = _a.value;
    return (React.createElement("div", { className: "flex flex-col gap-y-[4px]" },
        React.createElement("span", { className: "text-white font-N7" }, label),
        React.createElement("div", { className: "flex flex-row items-center gap-x-[8px]" },
            React.createElement("span", { className: "text-white font-N8 font-mono break-all" }, value || React.createElement("span", { className: "text-black-400" }, "(not set)")),
            value && (React.createElement(CopyButton, { textToCopy: value, className: "text-white shrink-0" })))));
};
